module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ;  if (locals.postageLabelUrl) { 
    ; __append(" <a href=\"")
    ; __append(escapeFn( locals.postageLabelUrl ))
    ; __append("\" target=\"_blank\" class=\"btn btn-secondary btn-block\">Label <span class=\"fa fa-download\"></span></a> ")
    ;  } 
    ; __append(" ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/shipments/postage_label_button.ejs
// module id = 1832
// module chunks = 1